import axios from "axios";

import { ApiErrorModel } from "@interfaces/index";
import { localStorageService } from "@services/index";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorageService.getToken() || "";
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response.status === 401 &&
      error.config &&
      !error.config._isRetry &&
      localStorageService.isTokenExpired()
    ) {
      localStorageService.incAttemptsErrorToken();
      if (localStorageService.getAttemptsErrorToken() === "11") {
        localStorageService.clearTokens();
        localStorageService.removeTokenExpired();
        window.location.href = "/login";
        return;
      }
    }

    if (
      error.response.status === 401 &&
      error.config &&
      !error.config._isRetry &&
      !localStorageService.isTokenExpired()
    ) {
      localStorageService.setTokenExpired();
      originalRequest._isRetry = true;
      try {
        const refresh_token = localStorageService.getRefreshToken();
        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/refresh`,
          {},
          { headers: { Authorization: `Bearer ${refresh_token}` } },
        );
        localStorageService.setTokens(
          response?.data?.token || "",
          response?.data?.refresh_token || "",
          false,
        );
        localStorageService.setAttemptsErrorToken("0");
        return api.request(originalRequest);
      } catch (error) {
        console.log(error);
        localStorageService.clearTokens();
        localStorageService.removeTokenExpired();
        window.location.href = "/login";
        return;
      }
    }
    const error500msg =
      "Unexpected Error! We're having some issues at the moment. We'll have it fixed in no time!";
    const fields = Object.keys(error.response.data.errors || {});
    const apiError: ApiErrorModel = {
      status: error.response.status,
      message:
        error.response.status === 500
          ? error500msg
          : error.response.data.message,
      fields: fields.reduce(
        (acc, field) => ({
          ...acc,
          [field]: error.response.data.errors[field][0],
        }),
        {},
      ),
    };
    throw apiError;
  },
);
